//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as settingAction from '../action/settingAction';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
//Material-ui
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Box from '@material-ui/core/Box';

import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';
import { UAParser } from 'ua-parser-js';

import PartPageTitle from './PartPageTitle';
//Dialog
import DialogConfirm from './DialogConfirm';
//Icon
import ClearIcon from '@material-ui/icons/Clear';
//image
import iconWebpush from '../img/icon/icon_webpush.jpg';


class Comp extends React.Component {
  constructor(props) {
		super(props);

    this.state = {
      webpushList: [],
      subscribed: false,
      isPushManager: false,
      isSubscribed: false,
      endpoint: null,
      publicKey: null,
      authToken: null,
      swReg: null,
      webpushDelId: null,
      info: null
    }
	}

  componentDidMount() {
    document.title = 'プッシュ通知の設定 - パートナーズ';

    if (process.env.NODE_ENV === 'production') {
      if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
        this.setState({isPushManager: false});
        this._webpushListGet(null);
      }
      else {
        this.setState({isPushManager: true});
        navigator.serviceWorker.register(process.env.PUBLIC_URL + '/service-worker.js').then((registration) => {
          this.setState({swReg: registration});

      		registration.pushManager.getSubscription().then((subscriptionData) => {
      			if (subscriptionData === null) {
      				//console.log(endpoint);
      				this._webpushListGet(null);
      			}
      			else {
      				let endpoint = subscriptionData.endpoint;
              this.setState({endpoint: endpoint});
      				//let publicKey = encodeBase64URL(subscriptionData.getKey('p256dh'));
      				//let authToken = encodeBase64URL(subscriptionData.getKey('auth'));
              this._webpushListGet(endpoint);
      			}
      		});
        });
      }
    }
    else {
      this._webpushListGet(null);
    }
  }

  _webpushListGet(endpoint) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'list');
    params.append('endpoint', endpoint);
    return axios.post(config.apiUri + "member/settingWebpushEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      if (res.data.bool) {
        this.setState({
          webpushList: res.data.list,
          subscribed: res.data.subscribed,
        })
      }
    })
    .catch((err) => {
      alert( config.apiErrComment );
    });
  }

  _urlB64ToUint8Array(base64String) {
  	var padding = '='.repeat((4 - base64String.length % 4) % 4);
  	var base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  	var rawData = window.atob(base64);
  	var outputArray = new Uint8Array(rawData.length);
  	for (var i = 0; i < rawData.length; ++i) {
  		outputArray[i] = rawData.charCodeAt(i);
  	}
  	return outputArray;
  }

  _encodeBase64URL(buffer) {
  	return btoa(String.fromCharCode.apply(null, new Uint8Array(buffer))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }


  _subscribe() {
  	let applicationServerKey = this._urlB64ToUint8Array('BLW3LGp2UgmVB29t8_EqPSPG5ad7cvtKC07Mx-sE9fSTIGSiD8ZwmUegzT6TXmnrfy6AoWcypflYwYdMfRvG86A');

    this.state.swReg.pushManager.permissionState({
  		userVisibleOnly: true,
  		applicationServerKey: applicationServerKey
  	}).then( (pushMessagingState) => {
      if (pushMessagingState === 'granted') {
        this.setState({info: null});
      }
  		else if(pushMessagingState === 'prompt') {
        this.setState({info: 'ブラウザのアドレスバーのダイアログから通知を許可してください'});
  		}
  		else if(pushMessagingState === 'denied') {
        this.setState({info: 'プッシュ通知がブロックされています。ブラウザのアドレスバーの左側に表示される。鍵マークをクリックして通知のブロックを解除してください'});
  		}
  	}).catch( (error) => {
  		alert(error);
  	});


    this.state.swReg.pushManager.subscribe({
  		userVisibleOnly: true,
  		applicationServerKey: applicationServerKey
  	}).then( (subscriptionData) => {
      let endpoint = subscriptionData.endpoint;
		  let publicKey = this._encodeBase64URL(subscriptionData.getKey('p256dh'));
		  let authToken = this._encodeBase64URL(subscriptionData.getKey('auth'));
      this.setState({endpoint: endpoint});
      this.setState({info: null});

      this.props.settingWebpushAdd(endpoint, publicKey, authToken, () => {
        this._webpushListGet(endpoint);
      })

    }).catch( (err) => {
      if (err === 'permission denied') {
        this.setState({info: 'プッシュ通知がブロックされています。ブラウザのアドレスバーの左側に表示される。鍵マークをクリックして通知のブロックを解除してください'});
      }
      else {
        console.log('Failed to subscribe the user: ', err);
      }
    });


  }

  _webpushDelSubmit(webpushDelId) {
    this.setState({ webpushDelId: null});
    this.props.settingWebpushDel(webpushDelId, () => {
      this._webpushListGet(this.state.endpoint);
    });
  }

  _renderList(value, index, arr) {
    let uaParser = new UAParser(value.webpush_userAgent);

		return (
      <div
        key={index}
        style={{
          padding:'5px',
          borderBottom: (arr.length - 1 > index) ? 'solid 1px #DDD': '',
        }}
      >
        <div
          style={{
            display:'flex',
            flexDirection:'column',
          }}>
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              justifyContent:'space-between',
            }}
          >
            <div style={{padding:'5px'}}>
              { uaParser.getOS().name  }&nbsp;{ uaParser.getOS().version }&nbsp;{ uaParser.getBrowser().name }
            </div>
            <IconButton
              onClick={ () => this.setState({ webpushDelId: value.webpush_id}) }
            >
              <ClearIcon />
            </IconButton>
          </div>
          { (value.subscribed) ? (<div style={{color:'red'}}>現在アクセス中のブラウザ</div>) : (null) }
        </div>
      </div>
    )
  }

  render() {
    let submitButton;
    if (!this.state.isPushManager) {
      submitButton = (
        <div style={{color:'red'}}>ブラウザがプッシュ通知に未対応です</div>
      )
    }
    else {
      if (!this.state.subscribed) {
        submitButton = (
          <Button
            variant="contained"
            color="primary"
            style={{minWidth:'240px'}}
            onClick={ () => this._subscribe() }
          >
            <span style={{fontSize:'1.4em'}}>プッシュ通知を送信する</span>
          </Button>
        )
      }
    }
    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <PartPageTitle
          title={'プッシュ通知の設定'}
          onback={ '/setting/' }
          helpType={ 'category' }
          helpFilter={ 'post' }
        />
        <div style={{margin:'10px'}} align='center'>
          <span className='i-b'>メール受信やお気に入り通知が</span>
          <span className='i-b'>ブラウザのプッシュ通知で届きます</span>
        </div>
        <div style={{margin:'10px'}} align='center'>
          <img
            src={iconWebpush}
            style={{width:'180px',height:'auto'}}
            alt=''
          />
        </div>

        <div align='center' style={{padding:'10px'}}>
          {
            submitButton
          }
          {
            (this.state.info !== null) && (
              <div style={{color:'red'}}>{this.state.info}</div>
            )
          }
        </div>
        <Box boxShadow={2} style={{background:'#FFF'}}>

          {
            this.state.webpushList.map(
              (value, index, arr) => this._renderList(value, index, arr)
            )
          }

        </Box>

        <DialogConfirm
          open={ (this.state.webpushDelId) ? true : false }
          title={'プッシュ通知'}
          content={'プッシュ通知から1件削除してもいいですか？'}
          apply={ () => this._webpushDelSubmit(this.state.webpushDelId) }
          close={ () => this.setState({webpushDelId: null}) }
        />

        <Snackbar
          open={this.state.saveSnackVisible}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          autoHideDuration={3000}
          onClose={ () => this.setState({saveSnackVisible: false})}
        >
          <MuiAlert severity="success" elevation={6} variant="filled">保存しました</MuiAlert>
        </Snackbar>

      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...settingAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
